// Размеры шрифтов
const fontsize_formats = [
  5,
  5.5,
  6.5,
  7.5,
  8,
  9,
  10,
  10.5,
  11,
  12,
  14,
  16,
  18,
  20,
  22,
  24,
  26,
  28,
  36,
  48,
  72
]
  .map(i => `${i}pt`)
  .join(" ");

export default fontsize_formats;
